import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Grid, Table } from "semantic-ui-react";
import { useStore } from "../../../app/stores/store";
import PageHeader from "../../../app/layout/PageHeader";


export default observer(function NextChargeAdjustments() {

  const { nextChargeAdjustmentsStore } = useStore();
  const { loadNextChargeAdjustments, getNextChargeAdjustments } =
    nextChargeAdjustmentsStore;

  useEffect(() => {
    loadNextChargeAdjustments();
  }, [loadNextChargeAdjustments]);

  return (
    <>
      <Grid stackable>
        <Grid.Row columns={1}>
          <Grid.Column>
            <PageHeader
              type="h1"
              header={"Next Charge Adjustments"}
              className="modal-text-color"
              textAlign="left"
              divider={false}
              addTitle
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid stackable>
        <Grid.Row columns={1}>
          <Table basic="very" striped unstackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="left">
                  Days Between Last Charge and Next Charge
                </Table.HeaderCell>
                <Table.HeaderCell>Count</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
                <Table.Body>
                  {getNextChargeAdjustments.map(n => (
                    <Table.Row>
                      <Table.Cell textAlign="left">{n.days}</Table.Cell>
                      <Table.Cell>{n.count}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
          </Table>
        </Grid.Row>
      </Grid>
    </>
  );
});
